import { skipToken, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export function useFileFromLibrary(id: string | null) {
    return useQuery({
        queryKey: [`get-file-${id}`],

        queryFn: id ? () => sdClient.getFile({ id }) : skipToken,
    });
}
